import { LOCALES, KEYS } from '../constants';

const enCATranslations = Object.freeze({
  [LOCALES.L18N_LOCALE_ENGLISH_CA] : {
    [KEYS.L18N_KEY_LABEL_PARTNER_ROLE ]:"Partner Role",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR ]:"Integrator",
    [KEYS.L18N_KEY_LABEL_PROVIDER ]:"Provider",
    [KEYS.L18N_KEY_LABEL_PARTNER_LEVEL]:"Partner Level",
    [KEYS.L18N_KEY_LABEL_PARTNER_SPECIALIZATION ]:"Partner Specialization",
    [KEYS.L18N_KEY_LABEL_CISCO_POWERED_SERVICE ]:"Cisco Powered Service",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME ]:"Partner Name",
    [KEYS.L18N_KEY_LABEL_LOCATION ]:"Location",
    [KEYS.L18N_KEY_LABEL_COUNTRY ]:"Country",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME_KEYWORD ]:"Partner Name Keyword",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME_KEYWORD_S_ ]:"Partner Name Keyword(s)",
    [KEYS.L18N_KEY_LABEL_SORTING ]:"Sorting",
    [KEYS.L18N_KEY_LABEL_SPECIALIZATIONS ]:"Specializations",
    [KEYS.L18N_KEY_LABEL_PARTNER_SPECIALIZATIONS ]:"Partner Specializations",
    [KEYS.L18N_KEY_LABEL_PROVIDER_LEVEL_AND_CISCO_POWERED_SERVICES ]:"Provider Level and Cisco Powered Services",
    [KEYS.L18N_KEY_LABEL_GOLD_PROVIDER ]:"gold provider",
    [KEYS.L18N_KEY_LABEL_PREMIER_PROVIDER ]:"premier provider",
    [KEYS.L18N_KEY_LABEL_SELECT_PROVIDER ]:"select provider",
    [KEYS.L18N_KEY_LABEL_ELOQUA__GET_GUIDANCE]:"Get guidance",
    [KEYS.L18N_KEY_LABEL_ELOQUA__REQUEST_A_QUOTE ]:"Request a quote",
    [KEYS.L18N_KEY_LABEL_OPEN ]:"Open",
    [KEYS.L18N_KEY_LABEL_EXPAND ]:"Expand",
    [KEYS.L18N_KEY_LABEL_COLLAPSE ]:"Collapse",
    [KEYS.L18N_KEY_LABEL_CHOOSE_A_COUNTRY ]:"Choose a country/region",
    [KEYS.L18N_KEY_LABEL_CHOOSE_A_ROLE ]:"Choose a role",
    [KEYS.L18N_KEY_LABEL_CHOOSE_SPECIALIZATION_S_ ]:"Choose specialization(s)",
    [KEYS.L18N_KEY_LABEL_CHOOSE_CISCO_POWERED_SERVICE_S_ ]:"Choose Cisco Powered Service(s)",
    [KEYS.L18N_KEY_LABEL_CHOOSE_EXPERTISE_S]:"Choose Expertise(s)",
    [KEYS.L18N_KEY_LABEL_CHOOSE_LEVEL_S_ ]:"Choose level(s)",
    [KEYS.L18N_KEY_LABEL_PARTNER_COUNTRY ]:"Partner Country/Region",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR_LEVELS ]:"Integrator Levels",
    [KEYS.L18N_KEY_LABEL_PROVIDER_LEVELS ]:"Provider Levels",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR_SPECIALIZATIONS ]:"Integrator Specializations",
    [KEYS.L18N_KEY_LABEL_CISCO_POWERED_SERVICES ]:"Cisco Powered Services",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAMES ]:"Partner Names",
    [KEYS.L18N_KEY_LABEL_BACK ]:"Back",
    [KEYS.L18N_KEY_LABEL_ALL_RESULTS]:"All results",
    [KEYS.L18N_KEY_LABEL_ALL ]:"All",
    [KEYS.L18N_KEY_LABEL_SAVED ]:"Saved",
    [KEYS.L18N_KEY_LABEL_MY_PARTNERS ]:"My Partners",
    [KEYS.L18N_KEY_LABEL_ADD ]:"Add",
    [KEYS.L18N_KEY_LABEL_REMOVE ]:"Remove",
    [KEYS.L18N_KEY_LABEL_ADD_TO_COMPARE ]:"Add to compare",
    [KEYS.L18N_KEY_LABEL_SELECT_AT_LEAST_ONE_MORE ]:"Select at least one more",
    [KEYS.L18N_KEY_LABEL_COMPARE_SELECTED ]:"Compare selected",
    [KEYS.L18N_KEY_LABEL_REMOVE_FROM_COMPARATOR ]:"Remove from comparator",
    [KEYS.L18N_KEY_LABEL_COMPARE ]:"Compare",
    [KEYS.L18N_KEY_LABEL_PARTNER_LEVEL ]:"Partner Level",
    [KEYS.L18N_KEY_LABEL_PROCESSING_IN_PROGRESS]:"Processing in progress",
    [KEYS.L18N_KEY_LABEL_RESULT ]:"result",
    [KEYS.L18N_KEY_LABEL_RESULTS ]:"results",
    [KEYS.L18N_KEY_LABEL_NO_RESULTS ]:"No results",
    [KEYS.L18N_KEY_LABEL_RESULT_IN]:"result in",
    [KEYS.L18N_KEY_LABEL_RESULTS_IN]:"results in",
    [KEYS.L18N_KEY_LABEL_NO_RESULTS_IN]:"No results in",
    [KEYS.L18N_KEY_LABEL_PREVIOUS ]:"Previous",
    [KEYS.L18N_KEY_LABEL_PREV ]:"Prev",
    [KEYS.L18N_KEY_LABEL_NEXT ]:"Next",
    [KEYS.L18N_KEY_LABEL_SAVE ]:"Save",
    [KEYS.L18N_KEY_LABEL_EXPERTISE ]:"Expertise",
    [KEYS.L18N_KEY_LABEL_OVERVIEW ]:"Overview",
    [KEYS.L18N_KEY_LABEL_IS_A_CISCO ]:"is a Cisco",
    [KEYS.L18N_KEY_LABEL_ROLE_INTEGRATOR_DESCRIPTION]:"Integrators build end-to-end solutions for our customers. They primarily transact in a resale motion but bring their own unique expertise to solve customer business problems",
    [KEYS.L18N_KEY_LABEL_ROLE_PROVIDER_DESCRIPTION ]:"Providers are experts at delivering managed and cloud solutions. Customers are looking for more flexibility in how they consume solutions and providers are becoming more and more critical in the market.",
    [KEYS.L18N_KEY_LABEL_PAST_SEARCHES ]:"Past searches",
    [KEYS.L18N_KEY_LABEL_PAST_SEARCH ]:"Past search",
    [KEYS.L18N_KEY_LABEL_ROLES ]:"Roles",
    [KEYS.L18N_KEY_LABEL_TECHNOLOGY ]:"Technology",
    [KEYS.L18N_KEY_LABEL_INDUSTRIES ]:"Industries",
    [KEYS.L18N_KEY_LABEL_INTEGRATORS ]:"Integrators",
    [KEYS.L18N_KEY_LABEL_PROVIDERS ]:"Providers",
    [KEYS.L18N_KEY_LABEL_OTHER ]:"Other",
    [KEYS.L18N_KEY_LABEL_OTHERS ]:"Others",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_OTHER_PARTNERS]:"No other partners saved",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_INTEGRATORS ]:"No saved integrators",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_PROVIDERS ]:"No saved providers",
    [KEYS.L18N_KEY_LABEL_FILTER_BY_NEED ]:"filter by need",
    [KEYS.L18N_KEY_LABEL_SEARCH_BY_COMBINED_CRITERIA ]:"search by combined criteria",
    [KEYS.L18N_KEY_LABEL_SEARCH_BY_LOCATION ]:"search by location",
    [KEYS.L18N_KEY_LABEL_THERE_IS_ONE_PARTNER_SERVING_WORLDWIDE]:"There is 1 Partner serving worldwide",
    [KEYS.L18N_KEY_LABEL_THERE_ARE]:"There are",
    [KEYS.L18N_KEY_LABEL_PARTNERS_SERVING_WORLDWIDE]:"partners serving worldwide",
    [KEYS.L18N_KEY_LABEL_THERE_ARE_ONE_NO_PARTNERS_SERVING]:"There are no partners serving",
    [KEYS.L18N_KEY_LABEL_THERE_IS_ONE_PARTNER_SERVING_IN]:"There is 1 partner serving in",
    [KEYS.L18N_KEY_LABEL_PARTNERS_SERVING_IN]:"partners serving in",
    [KEYS.L18N_KEY_LABEL_THERE_ARE_ONE_PARTNERS_SERVING_IN]:"There are no partners serving in",
    [KEYS.L18N_KEY_LABEL_CHANGE_LOCATION]:"Change Location",
    [KEYS.L18N_KEY_LABEL_FILTER_BY_NEED]:"Filter by need",
    [KEYS.L18N_KEY_LABEL_SEARCH]:"Search",
    [KEYS.L18N_KEY_LABEL_BY_NAME_ONE_LEVEL_AND_EXPERTISE]:"by name, level and expertise",
    [KEYS.L18N_KEY_LABEL_SELECTED]:"selected",
    [KEYS.L18N_KEY_LABEL_NO_MATCHES_FOUND]:"No matches found",
    [KEYS.L18N_KEY_LABEL_RANK_UP]:"Rank up",
    [KEYS.L18N_KEY_LABEL_RANK_DOWN]:"Rank down",
    [KEYS.L18N_KEY_LABEL_NAME_UP]:"Name up",
    [KEYS.L18N_KEY_LABEL_NAME_DOWN]:"Name down",
    [KEYS.L18N_KEY_LABEL_LOGIN_REQUIRED]:"Login required",
    [KEYS.L18N_KEY_LABEL_YOU_MUST_ONE_PERFORM_THIS_ACTION]:"You must log in to perform this action",
    [KEYS.L18N_KEY_LABEL_SEARCH_RESTORATION_FAILED]:"Search restoration failed",
    [KEYS.L18N_KEY_LABEL_LOG_IN]:"Log In",
    [KEYS.L18N_KEY_LABEL_PARTNER_SUCCESSFULLY_SAVED]:"Partner successfully saved",
    [KEYS.L18N_KEY_LABEL_THE_PARTNER_ONE_NOT_BE_SAVED]:"The partner could not be saved",
    [KEYS.L18N_KEY_LABEL_PARTNER_SUCCESSFULLY_REMOVED]:"Partner successfully removed",
    [KEYS.L18N_KEY_LABEL_THE_PARTNER_ONE_NOT_BE_DELETED]:"The partner could not be deleted",
    [KEYS.L18N_KEY_LABEL_TYPE_A_ONE_LEVEL_OR_EXPERTISE]:"Type a keyword to search by name, level or expertise",
    [KEYS.L18N_KEY_LABEL_ROLE_DEVELOPER_DESCRIPTION]:"Developers are experts who build tailored software and hardware solutions on top of Cisco technology, resulting in unique solutions that bridge systems to deliver outcomes.",
    [KEYS.L18N_KEY_LABEL_ROLE_ADVISOR_DESCRIPTION]:"Advisors are experts with deep industry knowledge, who guide businesses as they explore solutions to complex business challenges.​",
    [KEYS.L18N_KEY_LABEL_DIVERSE_PARTNER]:"Diverse Partner",
    [KEYS.L18N_KEY_LABEL_ALPHABETICAL]:"Alphabetical",
    [KEYS.L18N_KEY_LABEL_MOST_EXPERTISE]:"Most Expertise",
    [KEYS.L18N_KEY_LABEL_DEVELOPER]:"Developer",
    [KEYS.L18N_KEY_LABEL_ADVISOR]:"Advisor",

    [KEYS.L18N_KEY_LABEL_FILTERS]:"Filters",
    [KEYS.L18N_KEY_LABEL_FILTER_VERB]:"Filter",
    [KEYS.L18N_KEY_LABEL_PARTNER_EXPERTISE]:"Partner Expertise",
    [KEYS.L18N_KEY_LABEL_DISMISS_VERB]:"Dismiss",
    [KEYS.L18N_KEY_LABEL_SPECIALIZATION]:"Specialization",
    [KEYS.L18N_KEY_LABEL_EXPERTISES]:"Expertises",
    [KEYS.L18N_KEY_LABEL_NO_DESCRIPTION_PROVIDED_DOT]: 'No description provided.',
    [KEYS.L18N_KEY_LABEL_ABOUT]:'About',
    [KEYS.L18N_KEY_LABEL_CLEAR_COMPARATOR]:'Clear comparator',
    [KEYS.L18N_KEY_LABEL_PARTNER_COMPARISON]: 'Partner comparison',
    [KEYS.L18N_KEY_LABEL_ROLE]: 'Role',
    [KEYS.L18N_KEY_LABEL_TECHNOLOGICAL_FOCUS]: 'Technological Focus',
    [KEYS.L18N_KEY_LABEL_DESCRIPTION]: 'Description',
    [KEYS.L18N_KEY_LABEL_CHOOSE_LANGUAGE_SELECTION]: 'Choose language selection',
    [KEYS.L18N_KEY_LABEL_LOG_OUT]:"Log Out",
    [KEYS.L18N_KEY_LABEL_INCLUSIVE_PARTNER]:"Inclusive Partner",

    [KEYS.L18N_KEY_LABEL_ABOUT_CISCO]: "About Cisco",
    [KEYS.L18N_KEY_LABEL_CONTACT_US]: "Contact Us",
    [KEYS.L18N_KEY_LABEL_CAREERS]: "Careers",
    [KEYS.L18N_KEY_LABEL_MEET_OUR_PARTNERS]: "Meet our Partners",
    [KEYS.L18N_KEY_LABEL_FEEDBACK]: "Feedback",
    [KEYS.L18N_KEY_LABEL_HELP]: "Help",
    [KEYS.L18N_KEY_LABEL_TERMS_AND_CONDITIONS]: "Terms & Conditions",
    [KEYS.L18N_KEY_LABEL_PRIVACY_STATEMENT]: "Privacy Statement",
    [KEYS.L18N_KEY_LABEL_COOKIES]: "Cookies",
    [KEYS.L18N_KEY_LABEL_TRADEMARKS]: "Trademarks",
    [KEYS.L18N_KEY_LABEL_SUPPLY_CHAIN_TRANSPARENCY]: "Supply Chain Transparency",
    [KEYS.L18N_KEY_LABEL_SITEMAP]: "Sitemap",
    [KEYS.L18N_KEY_LABEL_HOW_TO_BUY]: "How to Buy",
    [KEYS.L18N_KEY_LABEL_PARTNERS]: "Partners",
    [KEYS.L18N_KEY_LABEL_PRODUCTS_AND_SERVICES]: "Products and Services",
    [KEYS.L18N_KEY_LABEL_SOLUTIONS]: "Solutions",
    [KEYS.L18N_KEY_LABEL_SUPPORT]: "Support",
    [KEYS.L18N_KEY_LABEL_LEARN]: "Learn",
    [KEYS.L18N_KEY_LABEL_EXPLORE_CISCO]: "Explore Cisco",
    [KEYS.L18N_KEY_LABEL_MENU]: "Menu",
    [KEYS.L18N_KEY_LABEL_CLOSE]: "Close",
    [KEYS.L18N_KEY_LABEL_SEE_MORE]: "See more",
    [KEYS.L18N_KEY_LABEL_SEE_LESS]: "See less",
    [KEYS.L18N_KEY_LABEL_DONT_HAVE_AN_ACCOUNT]: "Don't have an account?",
    [KEYS.L18N_KEY_LABEL_SIGN_UP]: "Sign up"

  }
});

export default enCATranslations;
